import { defineChain } from 'viem'
import { chainConfig } from 'viem/zksync'

// Latest viem has this chain, however, newer package version clashes with current setup
// For this reason this and future chains could be defined in this folder.
export const zero = /*#__PURE__*/ defineChain({
  ...chainConfig,
  id: 543_210,
  name: 'ZERO Network',
  network: 'zero-network',
  nativeCurrency: {
    decimals: 18,
    name: 'ETH',
    symbol: 'ETH',
  },
  rpcUrls: {
    default: { http: ['https://rpc.zero.network/', 'https://zero.drpc.org'] },
  },
  blockExplorers: {
    default: {
      name: 'Zero Block Explorer',
      url: 'https://explorer.zero.network',
    },
  },
  testnet: false,
  contracts: {
    multicall3: {
      address: '0xF9cda624FBC7e059355ce98a31693d299FACd963',
    },
  },
})
